import { instagramPosts } from "@/mocks/content";
import { SITE_CONFIG } from "@/config/site";

export default function InstagramSection() {
  return (
    <section className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal flex flex-col items-center gap-6 text-center md:flex-row md:items-end md:justify-between md:text-left">
          <div>
            <span className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-current" />
              Instagram
            </span>
            <h2 className="font-heading text-3xl font-bold leading-[1.08] tracking-tight text-foreground-950 md:text-5xl">
              Comida em movimento, todo dia.
            </h2>
            <p className="mt-4 max-w-md text-base leading-relaxed text-foreground-600">
              Acompanhe pratos, bastidores e novidades da Play Menu em{" "}
              <span className="font-semibold text-foreground-950">
                {SITE_CONFIG.instagramHandle}
              </span>
              .
            </p>
          </div>

          <a
            href={SITE_CONFIG.instagramUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 px-7 py-3.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            <i className="ri-instagram-line text-lg" aria-hidden="true" />
            Seguir {SITE_CONFIG.instagramHandle}
          </a>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-3 md:gap-4">
          {instagramPosts.map((post, i) => (
            <a
              key={post.id}
              href={post.link}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label={post.alt}
              className="reveal group relative overflow-hidden rounded-xl md:rounded-2xl"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="aspect-square">
                <img
                  src={post.image}
                  alt={post.alt}
                  title={`${post.alt} · ${SITE_CONFIG.instagramHandle}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {post.video && (
                  <video
                    src={post.video}
                    poster={post.image}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    aria-label={`${post.alt} em vídeo`}
                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                )}
              </div>
              <div className="absolute inset-0 bg-foreground-950/0 transition-colors group-hover:bg-foreground-950/30" />
              {post.type === "video" && (
                <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/60 text-foreground-50 backdrop-blur">
                  <i className="ri-play-fill text-lg" aria-hidden="true" />
                </span>
              )}
              <span className="absolute bottom-3 left-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/60 text-foreground-50 opacity-0 backdrop-blur transition-opacity group-hover:opacity-100">
                <i className="ri-instagram-line text-lg" aria-hidden="true" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}